import DateTime from 'utils/datetime';
import ApprovedPipeIcon from '../../assets/pipemap/approved_pipe.png';
import RejectedPipeIcon from '../../assets/pipemap/rejected_pipe.png';
import ReviewPipeIcon from '../../assets/pipemap/review_pipe.png';
import ServicedPipeIcon from '../../assets/pipemap/serviced_pipe.png';

export const PIPE_STATUS = Object.freeze({
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  SERVICED: 'SERVICED',
  // LATE: 'LATE',
  // IN_COMPLETE: 'IN_COMPLETE',
});

export const formatMapData = (data) => {
  const tracker = {};
  data = data?.filter((item) => {
    if (!tracker[item?.id]) {
      tracker[item?.id] = true;
      return true;
    }
    return false;
  });

  const markers = data?.map(({ location, farmers, ...rest }, i) => {
    const isUnserviced = rest?.reviewStatus == null;
    const isUnserviced2 = rest?.secondReviewStatus == null;
    const isLate = DateTime.isAfter(
      rest?.servicedDate,
      rest?.dryingEventDueDate,
    );

    const isLateDryingEvent2 = DateTime.isAfter(
      rest?.secondServicedDate,
      rest?.secondDryingEventDueDate,
    );

    const isIncomplete = rest?.dryingEventTaskStatus === 'INCOMPLETE';
    const isIncomplete2 = rest?.secondDryingEventTaskStatus === 'INCOMPLETE';

    return {
      ...rest,
      lat: location?.y,
      lng: location?.x,
      label: rest?.name || `P${i + 1}`,
      farmer: farmers?.[0] || {},
      isUnserviced,
      isLate,
      isIncomplete,
      isUnserviced2,
      isLateDryingEvent2,
      isIncomplete2,
    };
  });

  return markers;
};

const MARKER_SIZE = {
  standard: {
    width: 70,
    height: 35,
  },
  large: {
    width: 70,
    height: 35,
  },
};

export const getMarkerConfig = (marker) => {
  let status = marker?.reviewStatus;

  // 1
  if (marker?.isUnserviced && !!marker?.installationImageReviewStatus) {
    status = marker?.installationImageReviewStatus;
  }

  // 2
  if (
    marker?.installationImageReviewStatus === PIPE_STATUS.APPROVED &&
    marker?.reviewStatus === PIPE_STATUS.IN_REVIEW
  ) {
    status = PIPE_STATUS.IN_REVIEW;
  }

  // 3

  if (
    marker?.reviewStatus === PIPE_STATUS.REJECTED ||
    marker?.installationImageReviewStatus === PIPE_STATUS.REJECTED
  ) {
    status = PIPE_STATUS.REJECTED;
  }

  // 4
  if (marker?.reviewStatus === PIPE_STATUS.APPROVED) {
    status = PIPE_STATUS.SERVICED;
  }

  // 5
  if (marker?.isIncomplete) {
    status = PIPE_STATUS.APPROVED;
  }

  // 6
  if (!(marker?.installationImageReviewStatus in PIPE_STATUS)) {
    status = marker?.reviewStatus ? marker?.reviewStatus : PIPE_STATUS.APPROVED;
    if (marker?.reviewStatus === PIPE_STATUS.APPROVED) {
      status = PIPE_STATUS.SERVICED;
    }
  }

  const config = {
    [PIPE_STATUS.APPROVED]: {
      icon: ApprovedPipeIcon,
      label: {
        color: '#000',
      },
      size: MARKER_SIZE.standard,
    },
    [PIPE_STATUS.IN_REVIEW]: {
      icon: ReviewPipeIcon,
      label: {
        color: '#000',
      },
      size: MARKER_SIZE.standard,
    },
    [PIPE_STATUS.REJECTED]: {
      icon: RejectedPipeIcon,
      label: {
        color: '#fff',
      },
      size: MARKER_SIZE.standard,
    },
    [PIPE_STATUS.SERVICED]: {
      icon: ServicedPipeIcon,
      label: {
        color: '#fff',
      },
      size: MARKER_SIZE.standard,
    },
    // [PIPE_STATUS.IN_COMPLETE]: {
    //   icon: ApprovedPipeIcon,
    //   label: {
    //     color: 'red',
    //   },
    //   size: MARKER_SIZE.large,
    // },
  };

  if (config[status]) {
    config[status].size = marker?.isLate
      ? MARKER_SIZE.large
      : MARKER_SIZE.standard;

    config[status].status = status;
  } else {
    status = PIPE_STATUS.IN_REVIEW;
    config[status].size = MARKER_SIZE.standard;
  }

  return config?.[status];
};

export const createMapControlIcon = (controlDiv, onClick, icon) => {
  const button = document.createElement('span');
  const img = document.createElement('img');
  img.src = icon;
  img.style.height = '50px';
  img.style.width = '50px';
  img.style.borderRadius = '50%';

  button.appendChild(img);

  controlDiv.appendChild(button);

  button.onclick = onClick;
};
